module.exports = __webpack_public_path__ + "static/media/s2.4ecbad63.svg";